import React from 'react';
import { Input, Modal } from '@iwoca/orion';
import { t } from '@lingui/macro';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useLocale } from 'hooks/useLocale';
import { InviteButton } from './InviteInformation/InviteButton';
import styles from './InviteModal.module.css';

type Props = {
  showModal: boolean;
  closeModal: () => void;
};
export const InviteModal: React.FunctionComponent<Props> = ({
  showModal,
  closeModal,
}) => {
  const { isDE } = useLocale();
  const { introducerCompany } = useIntroducerContext();
  const introducerCompanyId = introducerCompany?.id;

  const baseUrl = isDE ? 'partner/portal' : 'introducer/portal';
  const inviteLink = `https://${
    window && window.location.hostname
  }/${baseUrl}/register/?introducer=${introducerCompanyId}`;

  return (
    <Modal
      closeIcon
      headerBar
      isOpen={showModal}
      onClose={closeModal}
      title={t`Invite your colleagues`}
    >
      <div className={styles.inviteModal} data-testid="invite-modal-content">
        <div className={styles.info}>
          <p>
            {t`Copy and send this invite link to your colleagues so you can create and track applications together under one company account.`}
          </p>
        </div>
        <div className={styles.inviteLink}>
          <Input
            disabled
            className={styles.linkInput}
            type="text"
            data-testid="invite-link-input"
            name="inviteLinkInput"
            value={inviteLink}
            label={t`Shareable Invite Link`}
          />
        </div>
        <InviteButton text={inviteLink} />
      </div>
    </Modal>
  );
};
